if (document.getElementById('page-contact')) {
  page()
}
function page() {
  if (document.getElementsByClassName('mw_wp_form')[0]) {
    // MWのエラーを装飾する
    const errorList = document.querySelectorAll('.mw_wp_form .error')

    for (const error of errorList) {
      error.closest('.form__desc').classList.add('isError')
    }
  }
}
